module.exports = __webpack_public_path__ + "assets/high.0faa52cf.png";